<div class="nav-outer-wrap">
  <ng-scrollbar visibility="hover">
    <div class="navbar-content">
      <nz-layout>
        <nz-sider nzWidth="260px" nzCollapsible [(nzCollapsed)]="navCollapsed" [nzTrigger]="null">
          <ul class="sidebar-menu" nz-menu nzTheme="light" nzMode="inline" (mouseleave)="navMob()">
            <!-- ── DOCUMENTS RECEIVED submenu — first, where the flat Documents Received item was ── -->
            <li nz-submenu nzTitle="Documents Received" nzIcon="cloud-download" [(nzOpen)]="docSubmenuOpen">
              <ul>
                @for (sub of docSubmenus; track sub.status) {
                  <li
                    nz-menu-item
                    nz-tooltip
                    [nzTooltipTitle]="sub.title"
                    nzTooltipPlacement="right"
                    [nzTooltipMouseEnterDelay]="0.4"
                    [routerLink]="[docReceivedPath]"
                    [queryParams]="{ status: sub.status }"
                    routerLinkActive
                    [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored' }"
                    #rlaDoc="routerLinkActive"
                    [nzSelected]="rlaDoc.isActive"
                    [style.--nav-icon-color]="sub.color"
                    (click)="navMob()"
                  >
                    <div class="nav-item-row">
                      <span nz-icon [nzType]="sub.icon"></span>
                      <span class="nav-item-label">{{ sub.title }}</span>
                      @if (getDocCount(sub.countKey) > 0) {
                        <span class="nav-badge">
                          {{ getDocCount(sub.countKey) }}
                        </span>
                      }
                    </div>
                  </li>
                }
              </ul>
            </li>

            <!-- ── Flat menu items (Web Referral, Dashboard Analytics) ── -->
            @for (menu of visibleMenus; track menu; let i = $index) {
              <li
                nz-menu-item
                nz-tooltip
                [nzTooltipTitle]="menu.title"
                nzTooltipPlacement="right"
                [nzTooltipMouseEnterDelay]="0.4"
                [routerLink]="menu.route"
                [queryParams]="menu.queryParams"
                routerLinkActive
                [routerLinkActiveOptions]="{ exact: false }"
                #rla="routerLinkActive"
                [nzSelected]="rla.isActive"
                (click)="onClick(menu)"
              >
                <span nz-icon [nzType]="menu.icon"></span>
                <span>{{ menu.title }}</span>
              </li>
            }

            <!-- ── EXCEPTION QUEUE submenu ─────────────────── -->
            <li nz-submenu nzTitle="Exception Queue" nzIcon="exception" [(nzOpen)]="excSubmenuOpen">
              <ul>
                @for (sub of exceptionSubmenus; track sub; let i = $index) {
                  <li
                    nz-menu-item
                    nz-tooltip
                    [nzTooltipTitle]="sub.title"
                    nzTooltipPlacement="right"
                    [nzTooltipMouseEnterDelay]="0.4"
                    [routerLink]="[sub.link ?? '/exception-queue']"
                    [queryParams]="sub.link ? {} : sub.type ? { type: sub.type } : {}"
                    routerLinkActive
                    [routerLinkActiveOptions]="{ exact: false }"
                    #rlaEx="routerLinkActive"
                    [nzSelected]="rlaEx.isActive"
                    (click)="selectedIndex = 5; navMob()"
                  >
                    <div class="nav-item-row">
                      <span nz-icon [nzType]="sub.icon"></span>
                      <span class="nav-item-label">{{ sub.title }}</span>
                      @if (getCount(sub.countKey) > 0) {
                        <span class="nav-badge">
                          {{ getCount(sub.countKey) }}
                        </span>
                      }
                    </div>
                  </li>
                }
              </ul>
            </li>

            <!-- Hidden from nav menu for now — do not remove, route/component still exist.
            <li nz-submenu nzTitle="Queue" nzIcon="pic-right" [(nzOpen)]="queueSubmenuOpen">
              <ul>
                @for (q of queueSubmenus; track q; let i = $index) {
                  <li
                    nz-menu-item
                    nz-tooltip
                    [nzTooltipTitle]="q.title"
                    nzTooltipPlacement="right"
                    [nzTooltipMouseEnterDelay]="0.4"
                    [routerLink]="[q.link]"
                    [queryParams]="q.queryParams"
                    routerLinkActive
                    [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored' }"
                    #rlaQ="routerLinkActive"
                    [nzSelected]="rlaQ.isActive"
                    (click)="selectedIndex = 4; navMob()"
                  >
                    <div class="nav-item-row">
                      <span nz-icon [nzType]="q.icon"></span>
                      <span class="nav-item-label">{{ q.title }}</span>
                    </div>
                  </li>
                }
              </ul>
            </li>
            -->

            <!-- ── PACKET BUCKETS submenu ──────────────────── -->
            <li nz-submenu nzTitle="Packet Buckets" nzIcon="menu-fold" [(nzOpen)]="packetSubmenuOpen">
              <ul>
                @for (p of packetSubmenus; track p; let i = $index) {
                  @if (p.bucket === pendingReferralsBucket) {
                    <!-- Pending Referrals — nested submenu: Pending (the bucket as-is) / Priority (Crisis + ASAP only) -->
                    <li
                      nz-submenu
                      class="nested-bucket-submenu"
                      [nzTitle]="pendingReferralsTitle"
                      [(nzOpen)]="pendingReferralsSubmenuOpen"
                      [style.--nav-icon-color]="'#0078d4'"
                    >
                      <!-- .ant-menu-title-content is what every other row in this menu sits inside —
                           ng-zorro adds it itself for a string nzTitle and for every nz-menu-item,
                           but renders a TemplateRef bare. Menu rows are flex containers where antd
                           grows only that element (`> .ant-menu-title-content { flex: auto }`, with
                           overflow/ellipsis) and pins everything else (`> * { flex: none }`), so
                           without it this row's label is the one that wouldn't ellipsize like its
                           siblings when it outgrows the sidebar. -->
                      <ng-template #pendingReferralsTitle>
                        <span class="ant-menu-title-content">
                          <div class="nav-item-row">
                            <span nz-icon [nzType]="p.icon"></span>
                            <span class="nav-item-label">{{ p.title }}</span>
                          </div>
                        </span>
                      </ng-template>
                      <ul>
                        @for (pr of pendingReferralsSubmenus; track pr) {
                          <li
                            nz-menu-item
                            nz-tooltip
                            [nzTooltipTitle]="pr.title"
                            nzTooltipPlacement="right"
                            [nzTooltipMouseEnterDelay]="0.4"
                            [routerLink]="['/incoming-referral']"
                            [queryParams]="pr.priorityOnly ? { bucket: p.bucket, priorityOnly: 'true' } : { bucket: p.bucket }"
                            routerLinkActive
                            [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored' }"
                            #rlaPr="routerLinkActive"
                            [nzSelected]="rlaPr.isActive"
                            (click)="navMob()"
                          >
                            <div class="nav-item-row">
                              <span nz-icon [nzType]="pr.icon"></span>
                              <span class="nav-item-label">{{ pr.title }}</span>
                              @if (getPacketCount(pr.countKey) > 0) {
                                <span class="nav-badge">
                                  {{ getPacketCount(pr.countKey) }}
                                </span>
                              }
                            </div>
                          </li>
                        }
                      </ul>
                    </li>
                  } @else {
                    <li
                      nz-menu-item
                      nz-tooltip
                      [nzTooltipTitle]="p.title"
                      nzTooltipPlacement="right"
                      [nzTooltipMouseEnterDelay]="0.4"
                      [routerLink]="['/incoming-referral']"
                      [queryParams]="{ bucket: p.bucket }"
                      routerLinkActive
                      [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored' }"
                      #rlaP="routerLinkActive"
                      [nzSelected]="rlaP.isActive"
                      [class.nav-icon-danger]="p.bucket === 'System Error'"
                      [class.nav-icon-all]="p.bucket === allReferralsBucket"
                      [class.nav-icon-deleted]="p.bucket === deletedBucket"
                      (click)="navMob()"
                    >
                      <div class="nav-item-row">
                        <span nz-icon [nzType]="p.icon"></span>
                        <span class="nav-item-label">{{ p.title }}</span>
                        @if (getPacketCount(p.bucket) > 0) {
                          <span class="nav-badge">
                            {{ getPacketCount(p.bucket) }}
                          </span>
                        }
                      </div>
                    </li>
                  }
                }
              </ul>
            </li>

            <!-- ── ADMIN submenu (SystemAdmin / Administrator only) ────── -->
            @if (showAdminMenu) {
              <li nz-submenu nzTitle="Admin" nzIcon="laptop" [(nzOpen)]="adminSubmenuOpen">
                <ul>
                  @for (a of adminSubmenus; track a; let i = $index) {
                    <li
                      nz-menu-item
                      nz-tooltip
                      [nzTooltipTitle]="a.title"
                      nzTooltipPlacement="right"
                      [nzTooltipMouseEnterDelay]="0.4"
                      [routerLink]="[a.link]"
                      routerLinkActive
                      [routerLinkActiveOptions]="{ exact: false }"
                      #rlaA="routerLinkActive"
                      [nzSelected]="rlaA.isActive"
                      (click)="navMob()"
                    >
                      <div class="nav-item-row">
                        <span nz-icon [nzType]="a.icon"></span>
                        <span class="nav-item-label">{{ a.title }}</span>
                      </div>
                    </li>
                  }
                </ul>
              </li>
            }
          </ul>
        </nz-sider>
      </nz-layout>
    </div>
  </ng-scrollbar>

  <!-- Hidden gradient definition the collapse icon's SVG path fills from -->
  <svg width="0" height="0" style="position: absolute">
    <defs>
      <linearGradient id="nav-collapse-rainbow" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stop-color="#ef4444" />
        <stop offset="25%" stop-color="#f59e0b" />
        <stop offset="50%" stop-color="#22c55e" />
        <stop offset="75%" stop-color="#3b82f6" />
        <stop offset="100%" stop-color="#a855f7" />
      </linearGradient>
    </defs>
  </svg>

  <div
    class="nav-collapse-trigger"
    [class.is-collapsed]="navCollapsed"
    [title]="navCollapsed ? 'Expand menu' : 'Collapse menu'"
    (click)="toggleNav()"
  >
    <span class="collapse-icon-btn">
      <span nz-icon [nzType]="navCollapsed ? 'double-right' : 'double-left'" nzTheme="outline"></span>
    </span>
  </div>
</div>
